import React from "react";
import { cn } from "@/lib/utils";

export interface CardProps extends React.HTMLAttributes<HTMLDivElement> {}

export function Card({ className, ...props }: CardProps) {
  return (
    <div
      className={cn(
        "rounded-lg border border-gray-200 dark:border-gray-700 colorful:border-[#057dbb]/30 yellow:border-[#fbb615]/30 pink:border-[#df1b82]/30 orange:border-[#f36f26]/30 blue:border-[#057dbb]/30 red:border-[#c22034]/30 green:border-[#3ead49]/30 bg-white dark:bg-gray-800 colorful:bg-white yellow:bg-white pink:bg-white orange:bg-white blue:bg-white red:bg-white green:bg-white colorful:shadow-lg colorful:shadow-[#057dbb]/5 yellow:shadow-lg yellow:shadow-[#fbb615]/5 pink:shadow-lg pink:shadow-[#df1b82]/5 orange:shadow-lg orange:shadow-[#f36f26]/5 blue:shadow-lg blue:shadow-[#057dbb]/5 red:shadow-lg red:shadow-[#c22034]/5 green:shadow-lg green:shadow-[#3ead49]/5 shadow-sm",
        className
      )}
      {...props}
    />
  );
}

export function CardHeader({ className, ...props }: CardProps) {
  return <div className={cn("p-6 pb-4 colorful:border-b colorful:border-[#057dbb]/10 yellow:border-b yellow:border-[#fbb615]/10 pink:border-b pink:border-[#df1b82]/10 orange:border-b orange:border-[#f36f26]/10 blue:border-b blue:border-[#057dbb]/10 red:border-b red:border-[#c22034]/10 green:border-b green:border-[#3ead49]/10", className)} {...props} />;
}

export function CardTitle({ className, ...props }: CardProps) {
  return (
    <h3
      className={cn("text-lg font-semibold text-gray-900 dark:text-gray-100 colorful:text-[#057dbb] yellow:text-[#fbb615] pink:text-[#df1b82] orange:text-[#f36f26] blue:text-[#057dbb] red:text-[#c22034] green:text-[#3ead49]", className)}
      {...props}
    />
  );
}

export function CardDescription({ className, ...props }: CardProps) {
  return (
    <div className={cn("text-sm text-gray-600 dark:text-gray-400 colorful:text-gray-700 yellow:text-[#78350f]/70 pink:text-[#831843]/70 orange:text-[#7c2d12]/70 blue:text-[#1e3a8a]/70 red:text-[#7f1d1d]/70 green:text-[#14532d]/70 mt-1", className)} {...props} />
  );
}

export function CardContent({ className, ...props }: CardProps) {
  return <div className={cn("p-6 pt-0", className)} {...props} />;
}

export function CardFooter({ className, ...props }: CardProps) {
  return (
    <div
      className={cn("p-6 pt-0 flex items-center gap-2", className)}
      {...props}
    />
  );
}
